<script>
import { UserStore, TempUserStore } from "./store.js";
import { BaseUrl } from "../../store.js";
import {  createEventDispatcher } from "svelte";
 import { fly } from 'svelte/transition';
const dispatch = createEventDispatcher();
const initiateUserStore = () => {

  UserStore.set({registerUser:{
    uid: 0,
    title: "",
    firstName: "",
    lastName: "",
    address: "",
    postcode: "",
    isMemberOfCrownService: false,
    email: "",
    confirmEmail: "",
    Hometel: "",
    Worktel: "",
    Mobile: "",
    password: "",
    confirmPassword: "",
    isPrivacyPolicyAgreed: false,	
    hasCompletedDetailsStep: false,
    hasCompletedContactDetailsStep: false,
  }});

  TempUserStore.set({registerDetails: {
    title: {value: $UserStore.registerUser.title, isDirty: false, isValid: true},
    firstName: {value: $UserStore.registerUser.firstName, isDirty: false, isValid: false},
    lastName: {value: $UserStore.registerUser.lastName, isDirty: false, isValid: false},
    address: {value: $UserStore.registerUser.address, isDirty: false, isValid: false},
    postcode: {value: $UserStore.registerUser.postcode, isDirty: false, isValid: false},
    isMemberOfCrownService: {value: $UserStore.registerUser.isMemberOfCrownService, isDirty: false, isValid: true},
  }, 
    registerContactDetails: {
      email: {value: $UserStore.registerUser.email, isDirty: false, isValid: false},
      confirmEmail: {value: $UserStore.registerUser.confirmEmail, isDirty: false, isValid: false},
      Hometel: {value: $UserStore.registerUser.Hometel, isDirty: false, isValid: false},
      Worktel: {value: $UserStore.registerUser.Worktel, isDirty: false, isValid: false},
      Mobile: {value: $UserStore.registerUser.Mobile, isDirty: false, isValid: false},
    }, 
    registerPassword: {
    password: {value: $UserStore.registerUser.password, isDirty: false, isValid: false },
    confirmPassword: {value: $UserStore.registerUser.confirmPassword, isDirty: false, isValid: false },
    isPrivacyPolicyAgreed: {value: $UserStore.registerUser.isPrivacyPolicyAgreed, isDirty: false, isValid: false },
    //la_id: {value: registerUser.address.la_id, isDirty: false },
    }
  })
 dispatch("pageChange", "/register/details");
}
</script>

<div class="box">
  <div class="field">
    <a href="/">
      <span class="fas fa-arrow-left" />
      Back
    </a>
  </div>
 
  <h1 class="title is-4">Create New Account </h1>
  <p class="subtitle is-6">
    Completing this form will create a new account on the
    <a href="/" style="text-decoration: underline;">eAdmissions website</a>.
  </p>
  <p>
    You can then easily find details about the schools maintained by the 33
    London Local Authorities and Surrey County Council, and complete an
    application online.
  </p>
  <p>
    A video describing the account creation process can be viewed <a href="https://www.youtube.com/watch?v=o2WXUD8Fido" target="_blank"> here</a>.
  </p>
  <hr />
  <div style="text-align: right;">
    <button type="button" on:click={initiateUserStore} class="button is-purple">Continue</button>
  </div>
</div>
